/**
 * Get Store Deliveries Timeline Use Case — Business Logic Layer (Clean Architecture).
 * جلب سجل تسليمات متجر
 */

import {StoreDeliveriesRepository, StoreDeliveriesTimelineResult} from '../repository/StoreDeliveriesRepository';
import {StoreDeliveryFilters} from '../models/storeDeliveries.model';

export class GetStoreDeliveriesTimelineUseCase {
  constructor(private readonly repository: StoreDeliveriesRepository) {}

  async execute(storeId: string, filters: StoreDeliveryFilters = {}): Promise<StoreDeliveriesTimelineResult> {
    if (!storeId) {
      throw new Error('Store ID is required');
    }
    return this.repository.getTimeline(storeId, filters);
  }
}
